import React from 'react';
import { PopupTooltip } from './PopupTooltip.js';
import '../../_rollupPluginBabelHelpers-mO86zOh3.js';
import '@emotion/react';
import '../../index-D7dZz-Df.js';
import '../../utils/mergeRefs.js';
import 'use-debounce';
import '@indeed/ihl-use-id';
import '../../utils/transition.js';
import '../../hooks/useIsomorphicLayoutEffect.js';
import '../Popup/Popup.js';
import '@floating-ui/react-dom';
import '@indeed/ifl-css';
import '../../hooks/useMergeRefs.js';
import '../Box/Box.js';
import '../Portal/Portal.js';
import 'react-dom';
import '../IndeedThemeProvider/IndeedThemeProvider.js';
import '@indeed/ifl-icons';
import '../IndeedThemeProvider/utils.js';
import '../IndeedThemeProvider/theme.js';
import 'deepmerge';
import '@indeed/ifl-themes';
import '../LinkProvider/LinkProvider.js';

/**
 * @see https://experience.indeed.design/components/ids/tooltip
 */
const Tooltip = props => /*#__PURE__*/React.createElement(PopupTooltip, props);
Tooltip.displayName = "Tooltip";

export { Tooltip };
